<template>
    <div>
        <Leftmenu />
        <Header />
        <div class="content">
            <div class="content-header">Еще увидимся :))</div>
        </div>
    </div>
</template>

<style scoped src="../assets/style/main.css"></style>

<script>
import Leftmenu from '@/components/leftmenu.vue'
import Header from '@/components/header.vue'

export default {
    name: 'Logout',
    components: {
        Leftmenu, Header
    },
    methods: {
        logout() {
            localStorage.removeItem('token')
            localStorage.removeItem('token_type')
            localStorage.removeItem('admin')
            localStorage.removeItem('surname')
            localStorage.removeItem('name')
            localStorage.removeItem('email')
            localStorage.removeItem('user_id')
            localStorage.removeItem('permissions')

            this.$router.push('/login')
        }
    },
    created() {
        this.logout()
    }
}
</script>